import { Page } from '@cast/shared-layout-ui';
import { DrawerProvider } from '@cast/design-system';
import { ClusterDashboardTimeRangeProvider } from '@cast/features-cluster-shared';

import { ClusterDashboard } from '@oneclick/features/cluster-dashboard';

export const ClusterDashboardPage = () => (
  <ClusterDashboardTimeRangeProvider>
    <DrawerProvider>
      <Page analytics="Cluster Dashboard" testId="cluster-dashboard">
        <ClusterDashboard />
      </Page>
    </DrawerProvider>
  </ClusterDashboardTimeRangeProvider>
);
